import 'babel-polyfill'

// element-ui import start
import '../theme/index.css'
import ElementUI from 'element-ui'
// element-ui import end

import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VueCookie from 'vue-cookie'
import VueRouter from 'vue-router'
import infiniteScroll from 'vue-infinite-scroll'

import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from './store'
import { i18n } from '@/i18n'
import { formatDate } from './filters'
import { helper } from './utils'
import {
  App as AppView,
  Dialog,
  InfoBox,
  TimelineLog,
  UserInfo
} from './components'
import config from './config'
import { plugin as API, updateAuthHeader } from './api'

import validationZHMessages from 'vee-validate/dist/locale/zh_TW'
import validationENMessages from 'vee-validate/dist/locale/en'

Vue.component('hamv-dialog', Dialog)
Vue.component('hamv-info-box', InfoBox)
Vue.component('timeline-log', TimelineLog)
Vue.component('user-info', UserInfo)

Vue.use(ElementUI)
VeeValidate.Validator.extend('emails', {
  validate: value => value.split(',').every(x => VeeValidate.Validator.rules.email.validate(x))
})

Vue.use(VeeValidate, {
  dictionary: {
    en: validationENMessages,
    zh: validationZHMessages
  },
  events: 'input|blur',
  fieldsBagName: 'formFields'
})
Vue.use(VueCookie)
Vue.use(VueRouter)
Vue.use(infiniteScroll)
Vue.use(API)

const router = new VueRouter({
  routes: routes,
  // mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})
Vue.filter('formatDate', formatDate)

const clearAuth = () => {
  window.console.log('Not authenticated')
  store.commit('SET_TOKEN', null)
  updateAuthHeader(Vue, null)
  store.commit('SET_USER', '')
  router.app.$cookie.delete('sid')

  window.localStorage.removeItem('uid')
  window.localStorage.removeItem('user')
  window.localStorage.removeItem('token')
}

router.beforeEach((to, from, next) => {
  let storeToken = router.app.$store.state.token
  storeToken = null
  if (router.app.$cookie.get('sid')) {
    storeToken = router.app.$cookie.get('sid')
  }

  const localStorageToken = window.localStorage.getItem('token')
  const noLoginPaths = config.noLoginPaths

  if ((noLoginPaths.indexOf(to.path) === -1) && (!storeToken || !localStorageToken)) {
    // logout
    clearAuth()
    next()
  } else if ((to.path === '/login/' || to.path === '/login') && storeToken) {
    next({ path: '/device' })
  } else {
    next()
  }
})

Vue.http.interceptors.push((request) => {
  if (request.method === 'GET' && document.documentMode) {
    request.headers.set('Cache-Control', 'no-cache')
    request.headers.set('Pragma', 'no-cache')
  }

  return (response) => {
    if (response.status === 403) {
      helper.showErrorMessage(ElementUI, 'general', response)

      clearAuth()
      router.push('/login')
    }
  }
})

sync(store, router)

// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  i18n,
  router: router,
  store: store,
  render: h => h(AppView)
})

if (window.localStorage) {
  const localUserToken = window.localStorage.getItem('token') || null
  const username = window.localStorage.getItem('user') || null

  if (localUserToken && store.state.token !== localUserToken) {
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }

  if (username) store.commit('SET_USER', username)
}

window.onbeforeunload = () => {
  // Refresh token
  const sid = router.app.$cookie.get('sid')
  if (sid) {
    router.app.$cookie.set('sid', sid, { expires: '30D' })
  }
}



// WEBPACK FOOTER //
// ./src/main.js